import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { useTranslation } from 'react-i18next'

interface Props {
    clickSelectFile(): void
    clickCamera(): void
    getDroppedFile(file: File): void
}

export const Base = ({
    clickSelectFile,
    getDroppedFile,
    clickCamera,
}: Props) => {
    const { t } = useTranslation()

    return (
        <Box sx={{ width: '100%' }}>
            <Button
                variant="contained"
                color="primary"
                sx={{
                    width: '100%',
                    textTransform: 'none',
                    fontSize: '16px',
                    py: '12px',
                    display: 'flex',
                }}
                onClick={clickSelectFile}
            >
                <UploadFileIcon sx={{ mr: '5px' }} /> {t('Seleccionar archivo')}
            </Button>
            <Button
                variant="contained"
                color="success"
                sx={{
                    width: '100%',
                    textTransform: 'none',
                    fontSize: '16px',
                    py: '12px',
                    display: 'flex',
                    mt: '15px',
                }}
                onClick={clickCamera}
            >
                <CameraAltOutlinedIcon sx={{ mr: '5px' }} />{' '}
                {t('Tomar la foto')}
            </Button>
            <Box
                sx={{
                    width: '100%',
                    border: '1px dashed var(--border-color)',
                    backgroundColor: 'var(--surface-soft)',
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: '15px',
                    height: '160px',
                    cursor: 'pointer',
                    transition: 'border-color 150ms ease',
                    '&:hover': {
                        borderColor: 'primary.main',
                    },
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                    e.preventDefault()
                    const file = e.dataTransfer.files[0]
                    if (!file) return
                    getDroppedFile(file)
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        color: 'text.secondary',
                    }}
                >
                    <FileDownloadOutlinedIcon sx={{ fontSize: '32px' }} />
                    <Typography sx={{ mt: '5px' }}>
                        {t('Arrastra un archivo')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}
